import React, { FC, useEffect } from 'react'
import { Text, Box, VStack, Image, Circle, LinkBox, LinkOverlay, Spinner } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { BaseHeading, Layout } from '../../components'
import useUtilStore from '../../state/Util.store'

const Insurance = () => {
  const [loading, fetchAvailablePolicies, values] = useUtilStore((state) => [
    state.loading,
    state.fetchAvailablePolicies,
    state.state
  ])

  useEffect(() => {
    fetchAvailablePolicies()
  }, [fetchAvailablePolicies])

  return (
    <Layout title="Buy Insurance">
      {loading ? (
        <VStack h="100%" justify="center" flex={1}>
          <Spinner size="xl" />
        </VStack>
      ) : (
        <>
          <BaseHeading title="What Would You like to Insure?" />
          <Text fontSize="1.2rem" mb="2rem">
            Please Select an Insurance Type to continue
          </Text>
          {values?.includes('vehicle') && (
            <BuyBox
              src="/images/buy-car.png"
              title="Motor Insurance"
              description="Protect yourself from liabilities incurred due to damages done to other vehicles."
              type="motor"
            />
          )}

          {values?.includes('gadget') && (
            <BuyBox
              title="Gadget Insurance"
              description="Protect your devices with our insurance plan.  Available for Samsung and Apple devices only."
              type="gadget"
              src="/images/buy-gadget.png"
            />
          )}
        </>
      )}
    </Layout>
  )
}

export { Insurance }

type Props = {
  title: string
  description: string
  type: string
  src: string
}

const BuyBox: FC<Props> = ({ title, description, type, src }) => {
  return (
    <LinkBox
      as={VStack}
      mt="1.6rem"
      pos="relative"
      border="1px solid #F7F7F7"
      borderRadius="1.6rem"
      overflow="hidden"
      boxShadow="0px 4px 12px rgba(154, 160, 166, 0.08)">
      <Box overflow="hidden" h="120px">
        <Image objectFit="cover" w="100%" src={src} />
      </Box>
      <Circle
        mt="0 !important"
        top="80px"
        right="2rem"
        pos="absolute"
        bg="#fff"
        size="4rem"
        boxShadow="0px 4px 8px rgba(154, 160, 166, 0.2)">
        {type === 'gadget' ? (
          <svg
            width="16"
            height="24"
            viewBox="0 0 16 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.78737 16.7667L8.6207 16.6334C8.55876 16.5913 8.49151 16.5577 8.4207 16.5334L8.2207 16.4445C8.04051 16.4068 7.85377 16.4145 7.67728 16.4669C7.5008 16.5192 7.34008 16.6146 7.20959 16.7445C7.11145 16.8525 7.03253 16.9765 6.97626 17.1111C6.89217 17.3136 6.86985 17.5364 6.9121 17.7515C6.95435 17.9666 7.05928 18.1644 7.2137 18.32C7.36811 18.4756 7.5651 18.582 7.77988 18.6259C7.99466 18.6698 8.21762 18.6492 8.4207 18.5667C8.55347 18.5023 8.67684 18.42 8.78737 18.3222C8.94154 18.166 9.04599 17.9676 9.08751 17.752C9.12904 17.5365 9.10579 17.3135 9.0207 17.1111C8.96531 16.9827 8.88614 16.8658 8.78737 16.7667ZM12.4429 0.888916H3.55404C2.66998 0.888916 1.82214 1.24011 1.19701 1.86523C0.571893 2.49035 0.220703 3.33819 0.220703 4.22225V19.7778C0.220703 20.6619 0.571893 21.5097 1.19701 22.1348C1.82214 22.7599 2.66998 23.1111 3.55404 23.1111H12.4429C13.327 23.1111 14.1748 22.7599 14.7999 22.1348C15.4251 21.5097 15.7763 20.6619 15.7763 19.7778V4.22225C15.7763 3.33819 15.4251 2.49035 14.7999 1.86523C14.1748 1.24011 13.327 0.888916 12.4429 0.888916ZM13.554 19.7778C13.554 20.0725 13.437 20.3551 13.2286 20.5635C13.0202 20.7719 12.7376 20.8889 12.4429 20.8889H3.55404C3.25935 20.8889 2.97674 20.7719 2.76836 20.5635C2.55999 20.3551 2.44293 20.0725 2.44293 19.7778V4.22225C2.44293 3.92756 2.55999 3.64495 2.76836 3.43658C2.97674 3.2282 3.25935 3.11114 3.55404 3.11114H12.4429C12.7376 3.11114 13.0202 3.2282 13.2286 3.43658C13.437 3.64495 13.554 3.92756 13.554 4.22225V19.7778Z"
              fill="#2E279D"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.02201 11.2C5.88412 11.2499 5.7589 11.3295 5.65521 11.4332C5.55152 11.5369 5.47191 11.6621 5.42201 11.8C5.34118 12.0019 5.3214 12.2231 5.3651 12.4362C5.40881 12.6492 5.51408 12.8448 5.66787 12.9986C5.82167 13.1524 6.01721 13.2576 6.23027 13.3013C6.44333 13.345 6.66453 13.3252 6.86645 13.2444C7.0011 13.1882 7.12512 13.1092 7.23312 13.0111C7.33126 12.9031 7.41018 12.7791 7.46645 12.6444C7.52865 12.5126 7.55909 12.368 7.55534 12.2222C7.55125 11.928 7.43615 11.6462 7.23312 11.4333C7.07687 11.2791 6.87845 11.1747 6.66291 11.1332C6.44737 11.0916 6.22435 11.1149 6.02201 11.2ZM20.622 6.75554L19.1109 2.27776C18.8804 1.62579 18.4528 1.06165 17.8875 0.663493C17.3221 0.265334 16.6468 0.0528705 15.9553 0.0555363H8.04423C7.35272 0.0528705 6.6775 0.265334 6.11212 0.663493C5.54673 1.06165 5.11917 1.62579 4.88867 2.27776L3.37756 6.78887C2.66681 6.97499 2.03747 7.39072 1.58737 7.97143C1.13727 8.55213 0.891646 9.26527 0.888672 9.99998V14.4444C0.890605 15.1321 1.1052 15.8024 1.50305 16.3634C1.90089 16.9243 2.46251 17.3485 3.11089 17.5778V18.8889C3.11089 19.1836 3.22796 19.4662 3.43633 19.6745C3.64471 19.8829 3.92732 20 4.22201 20C4.51669 20 4.79931 19.8829 5.00768 19.6745C5.21605 19.4662 5.33312 19.1836 5.33312 18.8889V17.7778H18.6665V18.8889C18.6665 19.1836 18.7835 19.4662 18.9919 19.6745C19.2003 19.8829 19.4829 20 19.7776 20C20.0722 20 20.3549 19.8829 20.5632 19.6745C20.7716 19.4662 20.8887 19.1836 20.8887 18.8889V17.5778C21.5371 17.3485 22.0987 16.9243 22.4965 16.3634C22.8944 15.8024 23.109 15.1321 23.1109 14.4444V9.99998C23.1079 9.26527 22.8623 8.55213 22.4122 7.97143C21.9621 7.39072 21.3328 6.97499 20.622 6.78887V6.75554ZM6.98867 2.97776C7.06321 2.75707 7.20522 2.56539 7.39464 2.42981C7.58405 2.29422 7.81129 2.2216 8.04423 2.2222H15.9553C16.1976 2.20956 16.4374 2.27657 16.638 2.413C16.8387 2.54943 16.9891 2.74778 17.0665 2.97776L18.2331 6.66665H5.76645L6.98867 2.97776ZM20.8887 14.4444C20.8887 14.7391 20.7716 15.0217 20.5632 15.2301C20.3549 15.4385 20.0722 15.5555 19.7776 15.5555H4.22201C3.92732 15.5555 3.64471 15.4385 3.43633 15.2301C3.22796 15.0217 3.11089 14.7391 3.11089 14.4444V9.99998C3.11089 9.7053 3.22796 9.42268 3.43633 9.21431C3.64471 9.00593 3.92732 8.88887 4.22201 8.88887H19.7776C20.0722 8.88887 20.3549 9.00593 20.5632 9.21431C20.7716 9.42268 20.8887 9.7053 20.8887 9.99998V14.4444ZM17.1331 11.2C16.9952 11.2499 16.87 11.3295 16.7663 11.4332C16.6626 11.5369 16.583 11.6621 16.5331 11.8C16.4523 12.0019 16.4325 12.2231 16.4762 12.4362C16.5199 12.6492 16.6252 12.8448 16.779 12.9986C16.9328 13.1524 17.1283 13.2576 17.3414 13.3013C17.5544 13.345 17.7756 13.3252 17.9776 13.2444C18.1154 13.1945 18.2407 13.1149 18.3444 13.0112C18.448 12.9075 18.5277 12.7823 18.5776 12.6444C18.6398 12.5126 18.6702 12.368 18.6665 12.2222C18.6624 11.928 18.5473 11.6462 18.3442 11.4333C18.188 11.2791 17.9896 11.1747 17.774 11.1332C17.5585 11.0916 17.3355 11.1149 17.1331 11.2ZM13.1109 11.1111H10.8887C10.594 11.1111 10.3114 11.2282 10.103 11.4365C9.89462 11.6449 9.77756 11.9275 9.77756 12.2222C9.77756 12.5169 9.89462 12.7995 10.103 13.0079C10.3114 13.2163 10.594 13.3333 10.8887 13.3333H13.1109C13.4056 13.3333 13.6882 13.2163 13.8966 13.0079C14.1049 12.7995 14.222 12.5169 14.222 12.2222C14.222 11.9275 14.1049 11.6449 13.8966 11.4365C13.6882 11.2282 13.4056 11.1111 13.1109 11.1111Z"
              fill="#2E279D"
            />
          </svg>
        )}
      </Circle>
      <Box pt="1.5rem !important" p="2rem">
        <BaseHeading fontSize="1.4rem" title={title} />
        <LinkOverlay fontSize="1.2rem" as={RouterLink} to={`buy-${type}`}>
          {description}
        </LinkOverlay>
      </Box>
    </LinkBox>
  )
}
